import React, { ReactElement, useEffect } from 'react';
import { Link } from 'idsk-react-components';
import { SprievodnyDokumentStatusEnum } from 'evidencna-aplikacia-frontend-ts-axios';
import PracovnyKrokRequest from '../../../../../../model/pracovnyKrok/PracovnyKrokRequest';
import PracovnyKrokComplete from './PracovnyKrokComplete';
import routes from '../../../../../../routing/routes';
import LegislativnyMaterialItem
  from '../../../../../../model/pracovnyKrok/LegislativnyMaterialItem';
import {
  usePracovnyKrokLegislativnyMaterialContext,
} from '../../../../../../context/PracovnyKrokLegislativnyMaterialContext';
import splitCisloLegMaterialu from '../../../../../../function/splitCisloLegMaterialu';
import useSprievodnyDokumentExists
  from '../../../../LegislativnyMaterialHistoria/hooks/useSprievodnyDokumentExists';
import { getLatestStadium } from '../../../../../../function/getLatestStadium';
import StadiumMaterialuHistoria
  from '../../../../../../model/legislativnyMaterial/StadiumMaterialuHistoria';

interface Props {
  legMaterial: LegislativnyMaterialItem;
  pracovnyKrok: PracovnyKrokRequest;
  reloadDetail?: () => void;
  reloadPracovneKroky?: () => void;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void;
  historiaRecords?: Array<StadiumMaterialuHistoria>,
}

const PredbezneStanovisko = ({
  legMaterial,
  pracovnyKrok,
  reloadDetail,
  reloadPracovneKroky,
  setIsDropdownOpened,
  historiaRecords,
}: Props): ReactElement => {
  const { type, year, index } = splitCisloLegMaterialu(legMaterial.cisloLegislativnehoMaterialu);
  const { setMaterial } = usePracovnyKrokLegislativnyMaterialContext();

  useEffect(
    () => setMaterial(legMaterial),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [legMaterial?.uuid, legMaterial?.typ, legMaterial?.cisloLegislativnehoMaterialu, setMaterial],
  );

  const stadiumUuid = historiaRecords ? getLatestStadium(historiaRecords)?.uuid : undefined;

  const { sprievodnyDokumentExistsStatus } = useSprievodnyDokumentExists(
    legMaterial?.uuid,
    stadiumUuid,
    'PredbezneStanovisko',
  );

  return (
    <>
      {sprievodnyDokumentExistsStatus?.status === SprievodnyDokumentStatusEnum.DocumentExists ? (
        <PracovnyKrokComplete
          legMaterial={legMaterial}
          pracovnyKrok={pracovnyKrok}
          confirmActionQuestion={`Naozaj si prajete vykonať pracovný krok "${pracovnyKrok.nazov}"?`}
          confirmActionDescription={'Po vykonaní tohto pracovného kroku bude odoslaná notifikácia NRSR, ktorá bude '
            + 'obsahovať dokument typu "Predbežné stanovisko", zo sprievodnej dokumentácie tohto '
            + 'procesu a proces bude presnutý do štádia "Zápis doplneného '
            + 'predbežného stanoviska k návrhu aktu EÚ".'}
          reloadDetail={reloadDetail}
          reloadPracovneKroky={reloadPracovneKroky}
          setIsDropdownOpened={setIsDropdownOpened}
        />
      ) : (
        <Link
          className="pracovny-krok__button"
          size="small"
          to={routes.procesy.prechodZapisStanoviska.withParams(type, year, index, pracovnyKrok.pracovnyKrokId)}
          type="link"
        >{pracovnyKrok.nazov}
        </Link>
      )}
    </>
  );
};

export default PredbezneStanovisko;
